/**
 * Allow only absolute http/https URLs. Rejects javascript:, data:, and
 * other schemes that would be unsafe in an href built from API data.
 */
export const toSafeHttpUrl = (raw?: string | null): string | undefined => {
  if (raw == null) return undefined;
  const trimmed = String(raw).trim();
  if (!trimmed) return undefined;
  // Control characters can disguise a dangerous scheme from casual checks.
  for (let i = 0; i < trimmed.length; i += 1) {
    const code = trimmed.charCodeAt(i);
    if (code <= 0x1f || code === 0x7f) return undefined;
  }

  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return undefined;
    }
    return parsed.href;
  } catch {
    return undefined;
  }
};
